<template>
    <v-flex xs12 sm10 md8>
      <v-card class="py-4">
        <v-flex xs12 px-4 pb-4 v-if="err">
          <v-alert type="error" :value="true">{{err}}</v-alert>
        </v-flex>
        <v-flex xs12 px-4 pb-4 v-if="success">
          <v-alert type="success" :value="true">{{success}}</v-alert>
        </v-flex>
        <v-form v-model="valid">
          <v-layout row wrap class="px-2">
            <v-flex xs12 md6 px-3>
              <v-autocomplete
                :items="companies"
                :label="$lang.actions.selectCompany"
                :readonly="isEdit"
                v-model="register.companyId"
                item-text="name"
                item-value="id"
                required
                :loading="companyLoading"
                :rules="[v => !!v || `${$lang.errors.missingCompany}`]"
              />
            </v-flex>
            <v-flex xs12 md6 px-3>
              <v-text-field
                :label="$lang.labels.cashRegisterName"
                :readonly="isEdit"
                v-model="register.cashRegisterName"
                :rules="[v => !!v || `${$lang.errors.required}`]"
                required
              />
            </v-flex>
            <v-flex xs12 md6 px-3>
              <v-text-field
                :label="$lang.labels.username"
                :readonly="register.status !== 'NEWENTRY' && isEdit"
                v-model="register.username"
                :rules="[v => !!v || `${$lang.errors.required}`]"
                required
              />
            </v-flex>
            <v-flex xs12 md6 px-3 v-if="register.status === 'NEWENTRY' || !isEdit">
              <v-text-field
                :label="$lang.labels.password"
                v-model="register.password"
                :rules="[v => !!v || `${$lang.errors.required}`]"
                required
              />
            </v-flex>
            <v-flex v-if="isEdit" xs12 md6 px-3>
              <v-text-field
                :label="$lang.labels.aesKey"
                readonly
                v-model="register.aesKey"
              />
            </v-flex>
            <v-flex v-if="isEdit" xs12 md6 px-3>
              <v-text-field
                :label="$lang.labels.aesKeyCheckSum"
                readonly
                v-model="register.aesKeyCheckSum"
              />
            </v-flex>
            <v-flex v-if="isEdit" xs12 md6 px-3>
              <v-text-field
                :label="$lang.labels.depAccessKey"
                readonly
                v-model="register.depAccessKey"
              />
            </v-flex>
            <v-flex v-if="isEdit" xs12 md6 px-3>
              <v-text-field
                :label="$lang.labels.status"
                readonly
                v-model="register.status"
              />
            </v-flex>
          </v-layout>
        </v-form>
        <v-flex
          v-if="isEdit && register.status !== 'CLOSED'"
          mx-3>
          <h3 class="mt-3 mx-2">{{ $lang.labels.actions }}:</h3>
          <v-layout row wrap>
            <v-btn
              v-if="register.status !== 'CLOSED' && register.status === 'NEWENTRY'"
              color="primary"
              @click="updateReciept('register')"
            >{{ $lang.actions.registerReciept }}</v-btn>
            <v-btn
              v-if="register.status !== 'CLOSED' && register.status === 'REGISTERED'"
              color="primary"
              @click="updateReciept('start')"
            >{{ $lang.actions.startReciept }}</v-btn>
            <v-btn
              v-if="register.status !== 'CLOSED' && register.status === 'INUSE'"
              color="primary"
              @click="updateReciept('null')"
            >{{ $lang.actions.nullReciept }}</v-btn>
            <v-btn
              v-if="register.status !== 'CLOSED' && register.status === 'INUSE'"
              color="primary"
              @click="updateReciept('end')"
            >{{ $lang.actions.endReciept }}</v-btn>
          </v-layout>
        </v-flex>
        <v-layout row wrap justify-space-between class="px-2">
          <v-flex xs12 md6 px-3>
            <v-text-field
              v-if="isEdit && register.createdOn"
              :label="$lang.labels.created"
              v-model="register.createdOn"
              readonly
            />
          </v-flex>
          <v-flex xs12 md6 px-3>
            <v-text-field
              v-if="isEdit && register.inUseFrom"
              :label="$lang.labels.inUseFrom"
              v-model="register.inUseFrom"
              readonly
            />
          </v-flex>
          <v-flex xs12 md6 px-3>
            <v-text-field
              v-if="isEdit && register.modifiedOn"
              :label="$lang.labels.modified"
              v-model="register.modifiedOn"
              readonly
            />
          </v-flex>
        </v-layout>
        <v-layout row justify-space-between class="px-2">
          <v-btn flat class="mx-3" @click="$router.push({ name: 'cashRegister' })"><v-icon>keyboard_arrow_left</v-icon> Close</v-btn>
          <v-btn class="primary mx-3" :disabled="!valid && register.status !== 'NEWENTRY'" @click="submit()">{{ isEdit ? $lang.actions.update : $lang.actions.create}}</v-btn>
        </v-layout>
      </v-card>
    </v-flex>
</template>

<script>
  import * as fetch_data from '../../assets/fetch_data';
  import {baseUrl} from '../../assets/url';
  import {DateTime} from 'luxon';

  export default {
    data: () => ({
      err:'',
      isEdit: false,
      success: '',
      valid: false,
      companies: [],
      companyLoading: true,
      register: {
        cashRegisterName: '',
        companyId: '',
        username: '',
        password: '',
        aesKey: '',
        aesKeyCheckSum: '',
        createdOn: '',
        inUseFrom: '',
        modifiedOn: '',
        depAccessKey: '',
        status: '',
      },
    }),
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd');
      },
      fetchCompanies() {
        this.$http.get('company')
          .then((res) => {
            if (res.body.status === 'Success') {
              this.companies = res.body.companies;
              this.companyLoading = false;
              return;
            }
            this.err = res.body.statusText;
            this.companyLoading = false;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
            this.companyLoading = false;
          });
        const edit = this.$cookie.get('companyedit');
        if (edit) this.register.companyId = edit;
      },
      fetchRegister(id) {
        this.$http.get(`cashregister/${id}`)
          .then((res) => {
            if (res.body.status === 'Success') {
              const register = {
                ...res.body.cashRegister,
                createdOn: this.formatDate(res.body.cashRegister.createdOn),
                inUseFrom: res.body.cashRegister.inUseFrom ? this.formatDate(res.body.cashRegister.inUseFrom) : '',
                modifiedOn: res.body.cashRegister.modifiedOn ? this.formatDate(res.body.cashRegister.modifiedOn) : null,
              }
              this.register = register;

            }
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
      updateReciept(action) {
        console.log(action);
        const id = this.register.id;
        let url = '';
        switch (action) {
          case 'start':
            url = `cashregister/startreceipt/${id}`;
            break;
          case 'end':
            url = `cashregister/endreceipt/${id}`;
            break;
          case 'null':
            url = `cashregister/nullreceipt/${id}`;
            break;
          default:
            url = `cashregister/depregistration/${id}`;
        }
        this.$http.post(url)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.success = res.body.statusText;
            }
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
      submit() {
        const url = this.isEdit ? `cashregister/update/${this.$route.params.id}` : `cashregister/create`;
        const payload = this.isEdit ? {
            cashRegisterName: this.register.cashRegisterName,
            username: this.register.username,
            password: this.register.password,
            depAccessKey: this.register.depAccessKey,
          } : {
            cashRegisterName: this.register.cashRegisterName,
            companyId: this.register.companyId,
            username: this.register.username,
            password: this.register.password,
          }
          this.$http.post(url, payload)
            .then((res) => {
              if (res.body.status === 'Success') {
                this.success = this.isEdit ? 'Register updated successfuly' : 'Register created successfuly';
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              this.err = err.body.statusText || err.body.message;
            });
      }
    },
    created() {
      this.fetchCompanies();
      if (this.$route.params.id) {
        this.isEdit = true;
        this.fetchRegister(this.$route.params.id)
      }
    },
  };
</script>



// WEBPACK FOOTER //
// CashRegisterDetails.vue?2a0ac8c2